import { type ReactNode } from 'react';
import { Box } from '@mui/material';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <Box
      sx={{
        minHeight: ['100vh', '100dvh', '100svh'],
        overflow: 'hidden',
        maxWidth: { xs: '100%', sm: 900 },
        px: { xs: 1.5, sm: 2 },
        margin: 'auto',
      }}
    >
      {children}
    </Box>
  );
};
